import React from "react";

export default function Header() {
  return (
    <div className="Header">
      <h1 className="text-primary">Shopping list</h1>
    </div>
  );
}
